(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pqp-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'pqp-mobile-navigation';

    if (customElements.get(elementName)) return;

    class PQPMobileNavigation extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
      }

      connectedCallback() {
        if (!document.documentElement.classList.contains('pqp-js')) return;
        if (this.listenersAttached) return;

        this.toggle = this.querySelector('.pqp-navigation__toggle');
        this.list = this.querySelector('.pqp-navigation__top-list');
        if (!this.toggle || !this.list) return;

        this.mobileViewport = window.matchMedia('(max-width: 749px)');
        this.toggle.addEventListener('click', this.handleToggle);
        this.list.addEventListener('click', this.handleLinkClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.mobileViewport.addEventListener('change', this.handleViewportChange);
        this.listenersAttached = true;
        this.setAttribute('data-mobile-navigation-enhanced', '');
        this.handleViewportChange();
      }

      disconnectedCallback() {
        if (!this.listenersAttached) return;

        this.toggle.removeEventListener('click', this.handleToggle);
        this.list.removeEventListener('click', this.handleLinkClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.mobileViewport.removeEventListener('change', this.handleViewportChange);
        this.listenersAttached = false;
      }

      handleToggle() {
        if (!this.mobileViewport.matches) return;

        if (this.toggle.getAttribute('aria-expanded') === 'true') {
          this.closeMenu();
        } else {
          this.setMenuOpen(true);
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          if (this.mobileViewport.matches) {
            if (this.toggle.getAttribute('aria-expanded') !== 'true') return;

            event.preventDefault();
            this.closeMenu(true);
            return;
          }

          this.handleDesktopEscape(event);
        }
      }

      handleDesktopEscape(event) {
        const activeElement = document.activeElement;
        let detail = activeElement instanceof Element ? activeElement.closest('details[open]') : null;

        if (!detail || !this.contains(detail)) {
          detail = event.target instanceof Element ? event.target.closest('details[open]') : null;
        }
        if (!detail || !this.contains(detail)) {
          detail = this.querySelector('details[open]');
        }
        if (!detail) return;

        const summary = detail.querySelector('summary');
        event.preventDefault();
        detail.open = false;
        if (summary) summary.focus();
      }

      handleLinkClick(event) {
        if (this.mobileViewport.matches && event.target.closest('a')) {
          this.closeMenu();
        }
      }

      handleViewportChange() {
        if (this.mobileViewport.matches) {
          const focusWasInList = this.list.contains(document.activeElement);
          this.closeMenu(focusWasInList);
          return;
        }

        this.setMenuOpen(false);
        this.list.hidden = false;
        this.closeDetails();
      }

      setMenuOpen(open) {
        this.toggleAttribute('data-mobile-menu-open', open);
        this.list.hidden = !open;
        if (open) {
          this.toggle.setAttribute('aria-expanded', 'true');
        } else {
          this.toggle.setAttribute('aria-expanded', 'false');
        }
      }

      closeDetails() {
        this.querySelectorAll('details[open]').forEach((detail) => {
          detail.open = false;
        });
      }

      closeMenu(returnFocus = false) {
        this.setMenuOpen(false);
        this.closeDetails();
        if (returnFocus) this.toggle.focus();
      }
    }

    customElements.define(elementName, PQPMobileNavigation);
  })();

  } catch(e) { console.error(e); }
})();
})();
